import { cookie } from './cookie';

const DEFERRED_ACTION_KEY = 'wix-chatbot-client-deffered-action';

export const getDeferredAction = () => cookie.is(DEFERRED_ACTION_KEY, 'true');

export const setDeferredAction = () => cookie.set(DEFERRED_ACTION_KEY, 'true');

export const cleanDeferredAction = () => cookie.remove(DEFERRED_ACTION_KEY);
